"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var ErrorMessage_1 = require("../../ErrorMessage/ErrorMessage");
var Theme_1 = require("../../Theme");
var Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 40px;\n    width: 100%;\n    border: 1px solid ", ";\n    background-color: white;\n    border-radius: 5px;\n    line-height: 1.3em;\n    font-size: ", ";\n    text-indent: 12px;\n    padding:0;\n    box-sizing: border-box;\n\n    &[disabled] {\n        opacity: ", ";\n    }\n\n"], ["\n    height: 40px;\n    width: 100%;\n    border: 1px solid ", ";\n    background-color: white;\n    border-radius: 5px;\n    line-height: 1.3em;\n    font-size: ", ";\n    text-indent: 12px;\n    padding:0;\n    box-sizing: border-box;\n\n    &[disabled] {\n        opacity: ", ";\n    }\n\n"])), Theme_1.Color.Grey.G30, Theme_1.FontSize, Theme_1.DisabledOpacity);
var TextInput = /** @class */ (function (_super) {
    __extends(TextInput, _super);
    function TextInput(props) {
        var _this = _super.call(this, props) || this;
        _this.hasChanged = false;
        _this.isValid = true;
        _this.buildStyle = function () {
            return {
                backgroundColor: _this.props.TransparentBackground ? "transparent" : "white",
                border: !_this.doesValueExist() || !_this.isValid ? "1px solid #e83a3a" : undefined,
            };
        };
        _this.doesValueExist = function () {
            if (_this.props.Required) {
                if (_this.state.Value === undefined || _this.state.Value === null) {
                    return false;
                }
                else if (_this.state.Value.trim().length === 0) {
                    return false;
                }
            }
            return true;
        };
        _this.renderErrorMessage = function () {
            if (!_this.doesValueExist()) {
                return React.createElement(ErrorMessage_1.ErrorMessage, { Message: _this.props.RequiredMessage, Icon: _this.props.RequiredIcon });
            }
            if (!_this.isValid) {
                _this.isValid = true;
                return React.createElement(ErrorMessage_1.ErrorMessage, { Message: _this.props.PatternMessage, Icon: _this.props.RequiredIcon });
            }
        };
        _this.handleBlur = function (e) {
            e.target.setCustomValidity("");
            e.target.checkValidity();
            if (_this.props.OnBlur && _this.hasChanged) {
                _this.props.OnBlur(_this.state.Value);
                _this.hasChanged = false;
            }
        };
        _this.handleChange = function (e) {
            if (!_this.props.ReadOnly && !_this.props.Disabled) {
                _this.hasChanged = true;
                var value_1 = _this.getMaxedLengthedValue(e.target.value);
                _this.setState({ Value: value_1 }, function () {
                    if (_this.props.OnChange) {
                        _this.props.OnChange(value_1);
                    }
                });
            }
        };
        _this.handleInvalid = function (e) {
            _this.isValid = false;
            e.target.setCustomValidity(" ");
            var value = _this.getMaxedLengthedValue(e.target.value);
            _this.setState({ Value: value }, function () {
                if (_this.props.OnInvalid) {
                    _this.props.OnInvalid(value);
                }
            });
        };
        _this.getMaxedLengthedValue = function (value) {
            if (_this.props.MaxLength &&
                _this.props.MaxLength > 0 &&
                value) {
                value = value.substr(0, _this.props.MaxLength);
            }
            return value;
        };
        var value = _this.getMaxedLengthedValue(props.Value);
        _this.state = { Value: value };
        return _this;
    }
    TextInput.prototype.UNSAFE_componentWillReceiveProps = function (nextProp) {
        this.setState({ Value: nextProp.Value });
    };
    TextInput.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Input, { style: this.buildStyle(), placeholder: this.props.Placeholder, maxLength: this.props.MaxLength, type: "text", value: this.state.Value, "aria-label": this.props.AriaLabel, readOnly: this.props.ReadOnly, disabled: this.props.Disabled, onChange: this.handleChange, onBlur: this.handleBlur, onInvalid: this.handleInvalid, required: this.props.Required, pattern: this.props.Pattern, id: this.props.ID, tabIndex: this.props.TabIndex ? this.props.TabIndex : 0 }),
            this.renderErrorMessage()));
    };
    return TextInput;
}(React.Component));
exports.TextInput = TextInput;
var templateObject_1;
